const KioscoCFDI = () => (
    <div className="uk-container-expand">
        <div className="uk-container uk-padding-large uk-text-justify">
            <p>Si ya timbras con nosotros, administra tus CFDI’s</p>
            <p>Dale acceso a tus empleados para que descargen sus recibos de nómina.</p>
            <p>Tus clientes pueden tener acceso para que descarguen sus propios CFDI’S.</p>
        </div>
    </div>
);


export default KioscoCFDI;